import React, { useEffect } from "react";
import { connect } from "react-redux";


const InfractionsSummary = ( props ) => {
  const {} = props;

  const infractions = [
      {
        id: 1,
        label: "Total",
        count: 1,
      },
      {
        id: 2,
        label: "Minor",
        count: 1,
      },    
      {
        id: 3,
        label: "Major",
        count: 0,
      },
      {
        id: 4,
        label: "Critical",
        count: 0,
      }
    ]
  
  	return (
      <div className="performance">
          <div className="space-y-2">
            <h4 className="text-[12px] font-semibold gap-2">
              Infractions (12 Months)
            </h4>
              <div className="grid grid-cols-2 gap-2">
                {infractions.map((item) => (
                  <div className={`p-2 rounded-lg card-content ${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    <p className="text-[9px] card-label">{item.label}</p>
                    <span className="text-[16px] font-semibold card-text">{item.count}</span>
                  </div>
                ))}
              </div>
              <div className="p-2 rounded-lg bg-green-50 border border-green-200">
                <p className="text-[9px] card-text">Days Without Incident</p>
                <span className="text-[16px] font-semibold card-text">49</span>
              </div>
          </div>
        </div>
);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(InfractionsSummary);
